import { styled } from '../../Utilities';
import { DatePickerBase } from './DatePicker.base';
import { styles } from './DatePicker.styles';
/**
 * DatePicker description
 */
export var DatePicker = styled(DatePickerBase, styles, undefined, {
    scope: 'DatePicker'
});
//# sourceMappingURL=DatePicker.js.map